import React, { createRef } from 'react';
import { Redirect, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Icon from '@material-ui/core/Icon';
import InputAdornment from '@material-ui/core/InputAdornment';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import Email from '@material-ui/icons/Email';
import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardFooter from '../../../components/Card/CardFooterTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Snackbar from '../../../components/Snackbar/Snackbar';
import loginPageStyle from '../../assets/jss/views/loginPageStyleTS';
import './LoginPageStyle.css';
import Logo from '../../assets/img/WISENE_logo_medium.png';
import Loading from '../../components/Loading/Loading';
import TextField from '@material-ui/core/TextField';
import { login, closeError, showCard } from '../../stores/actions/actions';
import { closeEmailNotification } from '../../stores/actions/accountActions';
import LoginIcon from '../../components/Icons/LoginIcon';
import { loaderStyle } from '../../helpers/CustomStyles';
import utils from '../../helpers/GlobalVariables';

interface loginCredentials {
	email: string;
	password: string;
}

interface ILoginPageProps {
	showError: boolean;
	token: string;
	cardAnimation: string;
	success: boolean;
	classes: ClassNameMap;
	login: (credentials: loginCredentials) => void;
	closeError: () => void;
	showCard: () => void;
	closeEmailNotification: () => void;
}

interface ILoginPageState {
	loginEmailError: boolean;
	loginEmailValue: string;
	loginPasswordError: boolean;
	loginPasswordValue: string;
	loginEmailFocusOut: boolean;
	loginPasswordFocusOut: boolean;
	mobileViewLocal: boolean;
	isLoaderRender: boolean;
}

class LoginPage extends React.Component<ILoginPageProps, ILoginPageState> {
	state: ILoginPageState = {
		loginEmailError: false,
		loginEmailValue: '',
		loginPasswordError: false,
		loginPasswordValue: '',
		loginEmailFocusOut: false,
		loginPasswordFocusOut: false,
		mobileViewLocal: false,
		isLoaderRender: false,
	};
	setTimeoutNotification: ReturnType<typeof setTimeout> = null;
	timeOutFunction: ReturnType<typeof setTimeout> = null;
	loginEmailRef = createRef<HTMLDivElement>();
	loginPasswordRef = createRef<HTMLDivElement>();

	onKeyDown = (event: KeyboardEvent): void => {
		const { loginPasswordValue, loginEmailValue, loginPasswordError, loginEmailError, isLoaderRender } = this.state;
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter' && !isLoaderRender && !loginEmailError && !loginPasswordError) {
			const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			event.preventDefault();
			event.stopPropagation();
			if (!loginPasswordValue) {
				this.setState({ loginPasswordError: true });
			}
			if (!loginEmailValue.match(emailRegex)) {
				this.setState({ loginEmailError: true });
			}
			if (!loginPasswordError && !loginEmailError) {
				this.submitForm();
			}
		}
	};

	submitForm = (): void => {
		const { loginEmailValue, loginPasswordValue, loginEmailError, loginPasswordError } = this.state;
		const { showError, closeError, login } = this.props;

		if (!loginEmailError && !loginPasswordError && loginEmailValue !== '' && loginPasswordValue !== '') {
			this.setState({ loginEmailError: false, isLoaderRender: true });
			clearTimeout(this.setTimeoutNotification);
			this.setTimeoutNotification = null;
			if (showError) {
				closeError();
			}
			let email = loginEmailValue;
			let password = loginPasswordValue;
			let credentials = { email, password };
			login(credentials);
		}
	};

	componentDidMount() {
		const { showCard, showError, closeError } = this.props;
		window.addEventListener('resize', this.onResize);
		// window.addEventListener('keydown', this.onKeyDown);
		this.onResize();
		if (this.loginEmailRef.current !== null && this.loginPasswordRef.current !== null) {
			this.loginEmailRef.current.addEventListener('focusout', this.onFocusOut);
			this.loginPasswordRef.current.addEventListener('focusout', this.onFocusOut);
		}
		this.timeOutFunction = setTimeout(showCard, 700);
		if (showError) {
			closeError();
		}
	}

	componentDidUpdate() {
		if (this.props.showError) {
			this.setTimeoutNotification = setTimeout(() => {
				this.props.closeError();
				this.setState({ isLoaderRender: false });
			}, 5500);
		}
	}

	onResize = (): void => {
		if (window.innerWidth < 800) {
			this.setState((prevState) => ({ ...prevState, mobileViewLocal: true }));
		} else {
			this.setState((prevState) => ({ ...prevState, mobileViewLocal: false }));
		}
	};

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
		// window.addEventListener('keydown', this.onKeyDown);
		clearTimeout(this.timeOutFunction);
		this.timeOutFunction = null;
		clearTimeout(this.setTimeoutNotification);
		this.setTimeoutNotification = null;
	}

	renderMobileNotifications = (): JSX.Element => {
		const { showError } = this.props;
		const { mobileViewLocal } = this.state;
		const headerStyle = utils.getHeaderStyle(showError);
		const emptyHeaderStyle = { margin: '34px 0 0 0' };

		if (mobileViewLocal && showError) {
			return (
				<h5 className='notification-open-login-page' style={headerStyle}>
					Wrong email or password
				</h5>
			);
		}
		return <div style={emptyHeaderStyle}></div>;
	};

	onChangeLoginValue = (e): void => {
		const { loginEmailFocusOut } = this.state;
		const currentValue = e.target.value;
		const containsIncorrectSign = utils.validateInputChars(currentValue);
		const isEmailIncorrect = utils.validateEmail(currentValue);
		const error = containsIncorrectSign || isEmailIncorrect;

		this.setState({ loginEmailValue: currentValue, loginEmailError: containsIncorrectSign });
		if (loginEmailFocusOut) {
			this.setState({ loginEmailValue: currentValue, loginEmailError: error });
		}
	};

	onChangePasswordValue = (e): void => {
		const { loginPasswordFocusOut } = this.state;
		const currentValue = e.target.value;
		if (currentValue === '') {
			this.setState({ loginPasswordError: true });
		} else {
			this.setState({ loginPasswordError: false });
		}

		if (loginPasswordFocusOut) {
			if (!currentValue) {
				this.setState({ loginPasswordError: true });
			}
		}

		this.setState({ loginPasswordValue: currentValue });
	};

	onFocusOut = (e): void => {
		const currentName = e.target.id;
		this.setState((state) => ({ ...state, [currentName + 'FocusOut']: true }));

		if (currentName === 'loginEmail') {
			this.onChangeLoginValue(e);
		}

		if (currentName === 'loginPassword') {
			this.onChangePasswordValue(e);
		}
	};

	render() {
		const { classes, showError, closeError, success } = this.props;

		const {
			loginEmailError,
			loginEmailValue,
			loginPasswordError,
			loginPasswordValue,
			mobileViewLocal,
			isLoaderRender,
		} = this.state;
		const gridStyle = { marginBottom: '15px' };
		if (success) {
			return <Redirect to={{
				pathname: "/pages/loading",
				state: this.props.location.state
			  }} />
		} else {
			return (
				<div className={`${classes.container} loginPage`}>
					<GridContainer
						justify='center'
						className='login-page-grid-container'
						direction='column'
						alignItems='center'
						// style={{ transform: 'translateY(30px)' }}
					>
						<GridItem xs={12}>
							<img className='wisene-logo' src={Logo} alt='wisene logo'></img>
						</GridItem>
						<GridItem md={8} lg={6}>
							<Card login className={classes[this.props.cardAnimation]}>
								<form>
									<CardHeader className={`${classes.cardHeader} ${classes.textCenter} login-page-card-header`} color='danger'>
										<LoginIcon className={classes.loginIcon} />
									</CardHeader>
									<CardBody>
										<TextField
											label='Email'
											id='loginEmail'
											error={loginEmailError}
											helperText={!this.state.loginEmailValue ? 'Email cannot be empty' : 'Incorrect email'}
											fullWidth
											onKeyDown={this.onKeyDown}
											required
											style={gridStyle}
											className={loginEmailError ? 'showAnimation' : ''}
											inputProps={{ maxLength: utils.defaultMaxEmailLength, autoCapitalize: 'off' }}
											InputProps={{
												value: loginEmailValue,
												onChange: (e) => this.onChangeLoginValue(e),
												ref: this.loginEmailRef,
												endAdornment: (
													<InputAdornment position='end'>
														<Email className={classes.inputAdornmentIcon} />
													</InputAdornment>
												),
											}}
										/>
										<TextField
											label='Password'
											id='loginPassword'
											error={loginPasswordError}
											helperText={'Password cannot be empty'}
											fullWidth
											required
											onKeyDown={this.onKeyDown}
											style={gridStyle}
											className={loginPasswordError ? 'showAnimation' : ''}
											inputProps={{ maxLength: utils.defaultMaxInputLength, autoCapitalize: 'off' }}
											InputProps={{
												value: loginPasswordValue,
												onChange: (e) => this.onChangePasswordValue(e),
												ref: this.loginPasswordRef,
												type: 'password',
												endAdornment: (
													<InputAdornment position='end'>
														<Icon className={classes.inputAdornmentIcon}>lock_intline</Icon>
													</InputAdornment>
												),
											}}
										/>

										<GridItem
											xs={12}
											style={{
												display: 'flex',
												justifyContent: 'flex-end',
												padding: '0',
											}}
										>
											<NavLink id='forgotPassword' to={'/pages/remind-password'}>
												Forgot password?
											</NavLink>
										</GridItem>
										<GridItem xs={12} className={'custom-notification'} style={{ padding: '0px' }}>
											{this.renderMobileNotifications()}
										</GridItem>
									</CardBody>
									<CardFooter className={classes.justifyContentCenter}>
										{isLoaderRender ? (
											<div style={loaderStyle}>
												<Loading transform={0.55} color='red' />
											</div>
										) : (
											<>
											<GridItem
												xs={12}
												style={{
													display: 'flex',
													justifyContent: 'center',
												}}
											>
												<Button
													data-testid='LoginButton'
													id='LoginButton'
													color='danger'
													onClick={this.submitForm}
													simple
													size='lg'
													disabled={
														isLoaderRender || loginEmailError || loginPasswordError || !loginEmailValue || !loginPasswordValue
													}
												>
													Log in
												</Button>
											</GridItem>
											<GridItem
												xs={12}
												style={{
													display: 'flex',
													justifyContent: 'center',
												}}
											>
												{'By logging in, you agree to our use of cookies for site functionality.'}
											</GridItem>
											</>
										)}
									</CardFooter>
								</form>
							</Card>
						</GridItem>
					</GridContainer>
					{!mobileViewLocal ? (
						<Snackbar
							close
							closeNotification={() => closeError()}
							color='danger'
							message='Wrong email or password'
							open={showError}
							place='tc'
						/>
					) : null}
				</div>
			);
		}
	}
}

const mapStateToProps = (state) => {
	return {
		showError: state.login.showError,
		token: state.login.token,
		cardAnimation: state.login.cardAnimation,
		success: state.login.success,
	};
};

const actions = {
	login,
	closeError,
	showCard,
	closeEmailNotification,
};

export default connect(mapStateToProps, actions)(loginPageStyle(LoginPage));
